import React from 'react'
import  Navbar  from '../inc/Navbar';
import Products from './Products';


function Productpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
          <br/>
        <br/>
        <div className="album py-0">
          <div className="container">
            <h1 style={{color:"#082a74"}}><b>Our Produccts</b></h1>
            </div>
          </div>
        <Products/>
    </div>
  )
}

export default Productpage